import { gql } from '@apollo/client';

export const CALCULATED_CREATIVE_DATA = gql`
  fragment calculatedCreativeData on CalculatedCreativeDataForAd {
    status
    transcodingStatus
    allowedPublisherList
    assetTagList {
      id
      displayName
    }
    rejectionReasons {
      assetId
      declines {
        reason
        externalComment
        internalComment
      }
    }
  }
`;
